module.exports = "/_next/static/images/icon_weather_41-5bf87489224eb0739badc830957f604e.svg";